<template>

        <div class="absolute bottom-0-space flex justify-center w-full">
              <i class="fa fa-shopping-cart cart-color" aria-hidden="true"></i>
            </div>

</template>
<style>
.bottom-0-space{
bottom: 6px;
}
</style>
